import { ICallAndSetData } from "@/services/api-service/interface";
import { getSetApiData } from "@/services/api-service/get-set-api-data";
import { EHttpMethod } from "@/services/api-service/enums";

export const SELECT_LINES_OF_BUSINESS_URL = "/v1/auth/select-lines-of-business";

export interface ISelectLinesOfBusinessPayload {
  /** The full list of line ids that should be selected (never a delta). */
  lineOfBusinessIds: string[];
}

/**
 * Persists the session's active lines of business. Non-2xx responses resolve with
 * `success: false` (body `code` is `SELECTION_EMPTY` or `LINE_NOT_ACCESSIBLE` on 400).
 */
const selectLinesOfBusinessApi: ICallAndSetData = async (
  callApi,
  callBack,
  payload?: ISelectLinesOfBusinessPayload,
) => {
  return getSetApiData(
    callApi,
    EHttpMethod.POST,
    SELECT_LINES_OF_BUSINESS_URL,
    callBack,
    payload,
    false,
  );
};

export { selectLinesOfBusinessApi };
